import { avatarFallbackColor } from '@affine/component';
import { UserIcon } from '@blocksuite/icons/lit';
import { cssVarV2 } from '@streamlain/theme/v2';
import { html } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';

/**
 * Placeholder avatar (no photo) of a member in lit menus such as the mention
 * popups: the same coloured initial as the React Avatar, 20 px with the
 * overlay panel's 1 px border like a photo.
 */
export function memberAvatarFallback(name?: string | null) {
  const label = name?.trim();
  if (!label) return UserIcon();
  const style = styleMap({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '20px',
    height: '20px',
    boxSizing: 'border-box',
    borderRadius: '50%',
    border: `1px solid ${cssVarV2('layer/background/overlayPanel')}`,
    backgroundColor: avatarFallbackColor(label),
    color: '#fff',
    fontSize: '10px',
    fontWeight: '600',
    lineHeight: '1',
  });
  return html`<span style=${style}>${[...label][0].toUpperCase()}</span>`;
}
